module.exports = __webpack_public_path__ + "static/img/flowimg.9f9d244.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/flowimg.png
// module id = xPda
// module chunks = 1